// Campus photo for /colleges/washington-state-university: CC BY-SA 3.0, by Joe Mabel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3APullman%2C_WA_-_view_of_WSU_campus_01.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/washington-state-university/; credited under the photo.
const photo = {
    "slug": "washington-state-university",
    "alt": "Washington State University campus buildings rising above the trees on College Hill in Pullman, Washington",
    "src": "/colleges/washington-state-university/campus-1600.webp",
    "srcSmall": "/colleges/washington-state-university/campus-800.webp",
    "srcMid": "/colleges/washington-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/washington-state-university/og.jpg",
    "title": "Pullman, WA - view of WSU campus 01",
    "author": "Joe Mabel",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3APullman%2C_WA_-_view_of_WSU_campus_01.jpg",
    "read": "2026-10-01"
};

export default photo;
